<template>
  <div class="el-aside ud-menu" :class="[!isCollapsed ? 'slide-enter' : 'slide-leave']">
    <!-- <div
      style="
        background-color: #4a5064;
        height: 30px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      "
      @click="collapsedSider"
    >
      <a
        :style="{ display: 'inline-block', margin: ' 0', color: '#fff' }"
        :class="rotateIcon"
      >
      </a>
    </div> -->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu v-if="authorition.name" class="el-menu" :default-active="calcMenuName($route.name)" :default-openeds="openeds" @open="handleOpen" @close="handleClose" :collapse="isCollapsed" :unique-opened="true">
        <template v-for="item in authorition.children">
          <el-menu-item :index="item.name" :key="item.name" @click="hanldeRoute(item.name)" v-if="!item.children || item.children.length === 0">
            <i class="menu-icon" :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
          <el-submenu popper-class="el-submenu" :index="item.name" :key="item.name" v-else>
            <template slot="title">
              <i class="menu-icon" :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <el-menu-item :index="item2.name" :key="item2.name" v-for="item2 in item.children" @click="hanldeRoute(item2.name)">{{ item2.title }}</el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
import { restoreUserAuthorities } from '../../../../utils';
import recurseToTree from '../../../../utils/recurseToTree';
// import { covertUserAuthorities } from '../../../../utils/index';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shrink: false,
      isCollapsed: this.value,
    };
  },
  created() {},
  methods: {
    calcMenuName(name) {
      console.log(name);
      return name.split('.').slice(0, 3).join('.');
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    hanldeRoute(name) {
      this.$router.push({ name });
    },
    collapsedSider() {
      // this.$refs.side1.toggleCollapse();
      this.isCollapsed = !this.isCollapsed;
      this.$emit('input', this.isCollapsed);
    },
  },

  mounted() {
    this.isCollapsed = this.value;
  },
  computed: {
    rotateIcon() {
      return ['iconfont-menu', !this.isCollapsed ? 'rotate-icon' : ''];
    },
    menuitemClasses() {
      return ['menu-item', this.isCollapsed ? 'collapsed-menu' : ''];
    },
    // openeds() {
    //   console.log(this.$route.name);
    //   const currentName = this.$route.name.split('.').slice(0, 2).join('.');
    //   const { userAuthorities } = this.$store.state;
    //   const authorities = userAuthorities.filter((item) => new RegExp(`^${currentName}`).test(item.name));
    //   console.log(authorities);
    //   return authorities.map((item) => item.name);
    // },
    openeds() {
      console.log(this.$route.name);
      const currentName = this.$route.name.split('.').slice(0, 2).join('.');
      const userAuthorities = restoreUserAuthorities(this.$store.state.userAuthorities);
      const authorities = userAuthorities.filter((item) => new RegExp(`^${currentName}`).test(item.name));
      return authorities.map((item) => item.name);
    },

    authorition() {
      const { userAuthorities } = this.$store.state;
      // const authorities = covertUserAuthorities(
      //   JSON.parse(JSON.stringify(userAuthorities)),
      // );
      // const authorition = authorities.filter((item) => new RegExp(`^${item.name.split('.')[0]}`).test(this.$route.name))[0];
      // return authorition || {};
      return { name: 'console', children: recurseToTree('id', 'parentId')(userAuthorities) };
    },
  },
  watch: {
    value(newValue) {
      this.isCollapsed = newValue;
    },
  },
};
</script>
<style lang="less" scoped>
.el-aside {
  overflow: hidden;
  width: 178px;
  height: 100%;
  background-color: #fff;
  border-right: solid 1px #dddee1;
  .menu-item {
    // height: calc(100% - 60px);
    max-width: 100%;
    height: 100%;
    bottom: 0;
    border-right: solid 1px #dddee1;
    overflow: auto;
    background-color: #fff;
  }
  .logo-con {
    padding: 8px;
    text-align: center;
    img {
      height: 44px;
      width: auto;
    }
  }
  &.slide-enter {
    transition: all 0.5s;
    width: 178px;
  }
  &.slide-leave {
    transition: all 0.5s ease-in;
    width: 64px;
  }
  .el-menu {
    border-right: 0;
    background-color: #fff;
    .menu-icon {
      position: relative;
      top: 2px;
      margin-right: 6px;
      font-size: 20px;
    }
  }
  // .el-menu > .el-submenu {
  //   background-color: #409eff;
  // }
  // .el-submenu > .el-menu {
  //   &.el-menu--inline {
  //     background-color: #409eff;
  //   }
  // }
}
.menu-icon {
  transition: all 0.3s ease-in;
}
.rotate-icon {
  display: inline-block;
  transition: all 0.3s ease-in;
  transform: rotate(-90deg);
}
</style>
